/* Elite Cases - esconde ",00" em preços redondos (R$ 229,00 -> R$ 229). Centavos reais continuam (R$ 22,99). */
(function () {
  var RE = /(R\$\s?\d{1,3}(?:\.\d{3})*),00(?!\d)/g;
  var IGNORAR = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, NOSCRIPT: 1 };

  function limpar(raiz) {
    if (!raiz) return;
    if (raiz.nodeType === 3) {
      if (raiz.nodeValue.indexOf(',00') !== -1 && !IGNORAR[(raiz.parentNode || {}).nodeName]) {
        var novo = raiz.nodeValue.replace(RE, '$1');
        if (novo !== raiz.nodeValue) raiz.nodeValue = novo;
      }
      return;
    }
    if (raiz.nodeType !== 1 || IGNORAR[raiz.nodeName]) return;
    var w = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) limpar(n);
  }

  // o snippet é incluído no início do <body>: observa a página enquanto ela é montada
  // e também quando o tema redesenha preços (troca de variante, carrinho, busca)
  new MutationObserver(function (lista) {
    lista.forEach(function (m) {
      if (m.type === 'characterData') limpar(m.target);
      else m.addedNodes.forEach(limpar);
    });
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  limpar(document.body);
  document.addEventListener('DOMContentLoaded', function () { limpar(document.body); });
  window.addEventListener('load', function () { limpar(document.body); });
})();